/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.BaseCountryResponseDto>
>;
export function request(
  params: API.basics.baseCountry.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCountry/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
